import React from "react";
import { Container, Grid, Paper, Typography, Box, Divider } from "@mui/material";
import { FaClock, FaMapMarkerAlt, FaLaptop, FaWhatsapp, FaChess, FaBookReader, FaChild, FaUserAlt } from "react-icons/fa";
import "./ClasesPage.css";

const ClasesPage = () => {
    return (
        <div className="page">
            <div className="pageHeader">Clases y Actividades</div>
            
            <Container maxWidth="lg" className="clases-container" sx={{ pt: 4 }}>
                <Box sx={{ mb: 6, textAlign: "left" }}>
                    <Typography 
                        variant="h5" 
                        component="h2" 
                        sx={{ 
                            color: "text.primary", 
                            mb: 2, 
                            fontWeight: 600, 
                            display: "flex", 
                            alignItems: "center", 
                            gap: 1.5 
                        }}
                    >
                        <FaChess style={{ color: "#3483eb" }} /> Actividades Club Ajedrez Pensado
                    </Typography>
                    <Typography variant="body1" sx={{ color: "text.secondary", maxWidth: "800px" }}>
                        Conoce las diferentes propuestas semanales que nuestro club ofrece para jugadores de todas las edades y niveles. 
                        ¡Encuentra tu grupo y participa de la experiencia de Ajedrez Pensado!
                    </Typography>
                </Box>

                {/* SECCION 1: PROPUESTAS DE LOS MIERCOLES */}
                <Box sx={{ mb: 6 }}>
                    <Typography 
                        variant="h6" 
                        sx={{ 
                            color: "#9295a9", 
                            textTransform: "uppercase", 
                            letterSpacing: "1px", 
                            fontWeight: 700, 
                            mb: 3 
                        }}
                    >
                        Propuestas de los Miércoles
                    </Typography>
                    
                    <Grid container spacing={4}>
                        {/* Clases Presenciales */}
                        <Grid item xs={12} md={6}>
                            <Paper
                                className="activity-card"
                                sx={{
                                    p: 4,
                                    bgcolor: "#161920",
                                    height: "100%",
                                    borderRadius: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    textAlign: "left"
                                }}
                                elevation={0}
                            >
                                <Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 600, color: "text.primary" }}>
                                            Clases Presenciales
                                        </Typography>
                                    </Box>
                                    
                                    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, bgcolor: "rgba(52, 131, 235, 0.15)", px: 1.5, py: 0.5, mb: 3 }}>
                                        <FaUserAlt style={{ color: "#3483eb", fontSize: "0.85rem" }} />
                                        <Typography variant="caption" sx={{ color: "#3483eb", fontWeight: 700 }}>
                                            Prof. Fernando Albarracín
                                        </Typography>
                                    </Box>

                                    <Divider sx={{ mb: 3, borderColor: "rgba(255, 255, 255, 0.08)" }} />

                                    <div className="icon-text-container">
                                        <div className="icon-wrapper">
                                            <FaClock />
                                        </div>
                                        <div>
                                            <Typography variant="body2" sx={{ color: "#9295a9", fontWeight: 600 }}>Horario</Typography>
                                            <Typography variant="body1" sx={{ color: "text.primary" }}>19:00 a 21:00 hs.</Typography>
                                        </div>
                                    </div>

                                    <div className="icon-text-container">
                                        <div className="icon-wrapper">
                                            <FaMapMarkerAlt />
                                        </div>
                                        <div>
                                            <Typography variant="body2" sx={{ color: "#9295a9", fontWeight: 600 }}>Lugar</Typography>
                                            <Typography variant="body1" sx={{ color: "text.primary" }}>
                                                Av. Maipú 267, Local C, Córdoba.
                                            </Typography>
                                        </div>
                                    </div>
                                </Box>

                                <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid rgba(255, 255, 255, 0.08)" }}>
                                    <Typography variant="body2" sx={{ color: "#9295a9", mb: 1 }}>Contacto e Inscripción</Typography>
                                    <a 
                                        href="https://wa.me/5493525523554" 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="contact-link"
                                    >
                                        <FaWhatsapp /> +54 9 3525 52-3554
                                    </a>
                                </Box>
                            </Paper>
                        </Grid>

                        {/* Club de Lectura */}
                        <Grid item xs={12} md={6}>
                            <Paper
                                className="activity-card"
                                sx={{
                                    p: 4,
                                    bgcolor: "#161920",
                                    height: "100%",
                                    borderRadius: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    textAlign: "left"
                                }}
                                elevation={0}
                            >
                                <Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 600, color: "text.primary" }}>
                                            Club de Lectura
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, bgcolor: "rgba(52, 131, 235, 0.15)", px: 1.5, py: 0.5, mb: 3 }}>
                                        <FaBookReader style={{ color: "#3483eb", fontSize: "0.85rem" }} />
                                        <Typography variant="caption" sx={{ color: "#3483eb", fontWeight: 700 }}>
                                            WIM Mili Brizzi
                                        </Typography>
                                    </Box>

                                    <Divider sx={{ mb: 3, borderColor: "rgba(255, 255, 255, 0.08)" }} />

                                    <div className="icon-text-container">
                                        <div className="icon-wrapper">
                                            <FaClock />
                                        </div>
                                        <div>
                                            <Typography variant="body2" sx={{ color: "#9295a9", fontWeight: 600 }}>Horario</Typography>
                                            <Typography variant="body1" sx={{ color: "text.primary" }}>19:00 a 20:30 hs.</Typography>
                                        </div>
                                    </div>

                                    <div className="icon-text-container">
                                        <div className="icon-wrapper">
                                            <FaLaptop />
                                        </div>
                                        <div>
                                            <Typography variant="body2" sx={{ color: "#9295a9", fontWeight: 600 }}>Modalidad</Typography>
                                            <Typography variant="body1" sx={{ color: "text.primary" }}>
                                                Online <Box component="span" sx={{ color: "#ffb74d", fontWeight: 600 }}>(Exclusivo para socios)</Box>
                                            </Typography>
                                        </div>
                                    </div>
                                </Box>

                                <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid rgba(255, 255, 255, 0.08)" }}>
                                    <Typography variant="body2" sx={{ color: "#9295a9", mb: 1 }}>Contacto e Inscripción</Typography>
                                    <a 
                                        href="https://wa.me/5493513070854" 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="contact-link"
                                    >
                                        <FaWhatsapp /> +54 9 3513 07-0854
                                    </a>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>

                {/* SECCION 2: SABADO (NIÑOS) */}
                <Box>
                    <Typography 
                        variant="h6" 
                        sx={{ 
                            color: "#9295a9", 
                            textTransform: "uppercase", 
                            letterSpacing: "1px", 
                            fontWeight: 700, 
                            mb: 3 
                        }}
                    >
                        Propuestas de los Sábados
                    </Typography>

                    <Grid container>
                        <Grid item xs={12}>
                            <Paper
                                className="activity-card"
                                sx={{
                                    p: 4,
                                    bgcolor: "#161920",
                                    borderRadius: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    textAlign: "left"
                                }}
                                elevation={0}
                            >
                                <Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 600, color: "text.primary" }}>
                                            👧👦 Clases para Niños
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, bgcolor: "rgba(52, 131, 235, 0.15)", px: 1.5, py: 0.5, mb: 3 }}>
                                        <FaChild style={{ color: "#3483eb", fontSize: "0.85rem" }} />
                                        <Typography variant="caption" sx={{ color: "#3483eb", fontWeight: 700 }}>
                                            Prof. Cristian Hernández
                                        </Typography>
                                    </Box>

                                    <Divider sx={{ mb: 3, borderColor: "rgba(255, 255, 255, 0.08)" }} />

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <div className="icon-text-container">
                                                <div className="icon-wrapper">
                                                    <FaClock />
                                                </div>
                                                <div>
                                                    <Typography variant="body2" sx={{ color: "#9295a9", fontWeight: 600 }}>Días y Horarios</Typography>
                                                    <Typography variant="body1" sx={{ color: "text.primary" }}>Sábados, 10:00 a 12:00 hs.</Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <div className="icon-text-container">
                                                <div className="icon-wrapper">
                                                    <FaMapMarkerAlt />
                                                </div>
                                                <div>
                                                    <Typography variant="body2" sx={{ color: "#9295a9", fontWeight: 600 }}>Lugar</Typography>
                                                    <Typography variant="body1" sx={{ color: "text.primary" }}>
                                                        Club Ajedrez Pensado (Av. Maipú 267, Local C).
                                                    </Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>

                                <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid rgba(255, 255, 255, 0.08)" }}>
                                    <Typography variant="body2" sx={{ color: "#9295a9", mb: 1 }}>Contacto e Inscripción</Typography>
                                    <a 
                                        href="https://wa.me/5493513320678" 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="contact-link"
                                    >
                                        <FaWhatsapp /> +54 9 3513 32-0678
                                    </a>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </div>
    );
};

export default ClasesPage;
